<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        style="margin-top: 6px;"
        v-on="on"
        :loading="loading"
        :disabled="loading || orders.length === 0"
        outline
        color="grey"
      >
        <v-icon>fa fa-print</v-icon>
        &nbsp;{{ $t('Receipt/ Tax invoice') }}
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile @click="ExportInvoicePDF('receipt')">
        <v-list-tile-title>{{ $t('Receipt') }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="ExportInvoicePDF('invoice')">
        <v-list-tile-title>{{ $t('Tax invoice') }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from 'vue'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import api from '@/api'
import { mapGetters } from 'vuex'
import THBText from 'thai-baht-text'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import { messages } from '../../../../lang/lang'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}
export default {
  data: function() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    })
  },
  props: ['orders'],
  methods: {
    ExportInvoicePDF(type) {
      this.loading = true
      var orderID = []
      this.orders.map(item => {
        orderID.push(item.id)
      })
      return new Promise((resolve, reject) => {
        api.generateOrderInvoice(
          {
            pageid: this.selectedBot.pageid,
            order_ids: orderID
          },
          (error, response) => {
            if (error) {
              this.loading = false
              reject(error)
            }
            if (response) {
              this.printPDF(response.data.result, type)
              resolve(response)
            }
          }
        )
      })
    },

    setProduct(product) {
      const lang = this.currentLang === 'th' ? 'th' : 'en'
      var setData = [
        [
          { text: this.getMsgFromLang(lang, 'Product list'), bold: true },
          { text: this.getMsgFromLang(lang, 'Count'), bold: true },
          { text: this.getMsgFromLang(lang, 'Price per unit'), bold: true },
          { text: this.getMsgFromLang(lang, 'total'), bold: true }
        ]
      ]
      product.map((item, i) => {
        setData.push([
          {
            text: [
              { text: `${i + 1} ${item.name}` },
              { text: item.option ? ` (${item.option})` : ' ' }
            ]
          },
          { text: item.quantity },
          { text: item.price_per_unit.toFixed(2) },
          { text: item.price.toFixed(2) }
        ])
      })
      return setData
    },

    setTextTotal(total) {
      const currentLocale = this.$i18n.locale()
      // const thaiTextBaht = THBText(total)
      return currentLocale === 'th' ? THBText(total) : this.genTextPrice(total)
    },

    async formatTemplate(orders, type) {
      const lang = this.currentLang === 'th' ? 'th' : 'en'
      dayjs.locale('th')
      var data = await Promise.all(
        orders.map(async (item, i) => [
          {
            text:
              type === 'receipt'
                ? this.getMsgFromLang(lang, 'Receipt')
                : `${this.getMsgFromLang(lang, 'Tax invoice')} / ${this.getMsgFromLang(
                    lang,
                    'Receipt'
                  )}`, //title
            style: 'header',
            alignment: 'center'
          },
          {
            text: `${this.getMsgFromLang(lang, 'No.')} ${item.invoice_no}`,
            style: 'subheader',
            alignment: 'center'
          },
          {
            text: `${this.getMsgFromLang(lang, 'Date')} ${dayjs(
              item.customer_address.invoice_date
            ).format('DD/MM/YYYY')}`,
            style: 'subheader',
            alignment: 'center'
          },
          '\n',
          {
            alignment: 'justify',
            columns: [
              {
                text: this.getMsgFromLang(lang, 'Seller'),
                bold: true
              },
              {
                text: this.getMsgFromLang(lang, 'Customer'),
                bold: true
              }
            ],
            margin: [0, 0, 0, 5]
          },
          // {
          //   columns: [
          //     {
          //       text: item.shop_address.name
          //     },
          //     {
          //       text: item.customer_address.name
          //     }
          //   ]
          // },
          {
            columns: [
              {
                text:
                  item.shop_address.name +
                  ' ' +
                  item.shop_address.addressno +
                  ' ' +
                  item.shop_address.sub_district +
                  ' ' +
                  item.shop_address.district +
                  ' ' +
                  item.shop_address.province +
                  ' ' +
                  item.shop_address.postcode +
                  ' ' +
                  `${this.getMsgFromLang(lang, 'Tel')} ` +
                  item.shop_address.tel
              },
              {
                text: item.customer_address.tax_address
                  ? `${item.customer_address.tax_name} ${item.customer_address.tax_address}`
                  : `${item.customer_address.name || ''} ${item.customer_address.addressno ||
                      ''} ${item.customer_address.sub_district || ''} ${item.customer_address
                      .district || ''} ${item.customer_address.province || ''} ${item
                      .customer_address.tax_id || ''} ${item.customer_address.tel || ''}`
              }
            ]
          },
          {
            alignment: 'justify',
            columns: [
              {
                text: `${this.getMsgFromLang(lang, 'Tax Identification Number')} ${
                  item.shop_address.tax_id
                }`
              },
              {
                text: `${this.getMsgFromLang(lang, 'Tax Identification Number')} ${
                  item.customer_address.tax_id ? item.customer_address.tax_id : '-'
                }`
              }
            ]
          },
          {
            margin: [0, 15, 0, 0],
            layout: 'lightHorizontalLines', // optional
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              headerRows: 1,
              widths: ['*', '*', '*', '*'],

              body:
                //   [
                //     { text: 'รายการสินค้า', bold: true },
                //     { text: 'จำนวน', bold: true },
                //     { text: 'ราคาต่อหน่วย', bold: true },
                //     { text: 'ยอดรวม', bold: true }
                //   ],
                this.setProduct(item.products)
              //   ['ๅ chatbot', '1', '4399', '4399'],
              //   ['2 chatbot', '1', '4399', '4399']
            }
          },
          {
            alignment: 'justify',
            columns: [
              {
                layout: 'lightHorizontalLines',
                table: {
                  widths: ['*'],
                  body: [
                    [
                      {
                        margin: [0, 0, 0, 40],
                        stack: [
                          { text: this.getMsgFromLang(lang, 'Remark'), bold: true },
                          { text: item.remark, margin: [0, 0, 0, 20] }
                        ]
                      }
                    ]
                  ]
                }
              },

              {
                layout: 'lightHorizontalLines',
                table: {
                  widths: ['*', '*', '*'],
                  body: [
                    [
                      {
                        stack: [
                          {
                            text: this.getMsgFromLang(lang, 'Sum'),
                            margin: [0, 0, 0, 0]
                          },
                          {
                            text: this.getMsgFromLang(lang, 'Discount'),
                            margin: [0, 10, 0, 0]
                          },
                          {
                            text: this.getMsgFromLang(lang, 'Shipping_cost'),
                            margin: [0, 10, 0, 0]
                          },
                          {
                            text: this.getMsgFromLang(lang, 'Price does not include VAT.'),
                            margin: [0, 10, 0, 0]
                          },
                          type === 'receipt'
                            ? {}
                            : {
                                text: this.getMsgFromLang(lang, 'VAT 7%'),
                                margin: [0, 10, 0, 0]
                              },
                          type === 'receipt'
                            ? {}
                            : {
                                text: this.getMsgFromLang(lang, 'Price includes VAT'),
                                margin: [0, 10, 0, 0]
                              }
                        ],
                        bold: true
                      },
                      {
                        stack: [
                          { text: item.subtotal.toFixed(2), margin: [0, 0, 0, 0] },
                          { text: item.discount.toFixed(2), margin: [0, 10, 0, 0] },
                          { text: item.shipping_cost.toFixed(2), margin: [0, 10, 0, 0] },
                          type === 'receipt'
                            ? {}
                            : {
                                text: item.total_not_include_tax.toFixed(2),
                                margin: [0, 10, 0, 0]
                              },
                          type === 'receipt'
                            ? {}
                            : { text: item.tax.toFixed(2), margin: [0, 10, 0, 0] },
                          { text: item.total.toFixed(2), margin: [0, 10, 0, 10] }
                        ]
                      },
                      {
                        stack: [
                          {
                            text: this.getMsgFromLang(lang, 'Baht'),
                            margin: [0, 0, 0, 0]
                          },
                          {
                            text: this.getMsgFromLang(lang, 'Baht'),
                            margin: [0, 10, 0, 0]
                          },
                          {
                            text: this.getMsgFromLang(lang, 'Baht'),
                            margin: [0, 10, 0, 0]
                          },
                          type === 'receipt'
                            ? {}
                            : {
                                text: this.getMsgFromLang(lang, 'Baht'),
                                margin: [0, 10, 0, 0]
                              },
                          type === 'receipt'
                            ? {}
                            : {
                                text: this.getMsgFromLang(lang, 'Baht'),
                                margin: [0, 10, 0, 0]
                              },
                          {
                            text: this.getMsgFromLang(lang, 'Baht'),
                            margin: [0, 10, 0, 0]
                          }
                        ]
                      }
                    ]
                  ]
                }
              }
            ],
            margin: [0, 15, 0, 0]
          },

          {
            layout: 'lightHorizontalLines',
            table: {
              body: [
                [
                  {
                    text: this.getMsgFromLang(lang, 'Amount in letters'),
                    margin: [0, 3, 0, 0],
                    bold: true
                  },
                  {
                    table: {
                      widths: [400],
                      body: [
                        [
                          {
                            stack: [
                              {
                                alignment: 'center',
                                text: this.setTextTotal(item.total),
                                margin: [0, 0, 0, 0],
                                bold: true
                              }
                            ]
                          }
                        ]
                      ]
                    }
                  }
                ]
              ]
            }
          },
          {
            alignment: 'center',
            columns: [
              {},
              {
                layout: 'lightHorizontalLines',
                table: {
                  widths: ['*'],
                  body: [
                    [
                      {
                        stack: [
                          // {
                          //   table: {
                          //     widths: ['*'],
                          //     body: [
                          //       [
                          //         {
                          //           stack: [
                          //             {
                          //               text: this.setTextTotal(item.total),
                          //               margin: [0, 0, 0, 0],
                          //               bold: true
                          //             }
                          //           ]
                          //         }
                          //       ]
                          //     ]
                          //   }
                          // },
                          await this.getBase64ImageFromURL(item.page_signature.img_url),
                          {
                            text: '____________________________',
                            margin: [0, -12, 0, 0]
                          },
                          // {
                          // image:
                          //   width: 100,
                          //   margin: [0, 10, 0, 0]
                          // },
                          {
                            text: item.page_signature.name,
                            margin: [0, 30, 0, 0]
                          },
                          {
                            text: '( ____________________________ )',
                            margin: [0, -10, 0, 0]
                          },
                          {
                            text: this.getMsgFromLang(lang, 'Payee'),
                            margin: [0, 10, 0, 0]
                          },
                          {
                            // text: dayjs(item.created_at)
                            //   .add(543, 'year')
                            //   .format('LL'),
                            text: '',
                            margin: [0, 10, 0, 0],
                            pageBreak: i + 1 === orders.length ? '' : 'after'
                          }
                        ]
                      }
                    ]
                  ]
                }
              }
            ]
          }
        ])
      )
      return data
    },

    getBase64ImageFromURL(url) {
      if (url) {
        return new Promise((resolve, reject) => {
          var img = new Image()
          img.setAttribute('crossOrigin', 'anonymous')
          img.onload = () => {
            var canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            var dataURL = canvas.toDataURL('image/png')
            resolve({
              image: dataURL,
              width: 100,
              margin: [0, 10, 0, 0]
            })
          }
          img.onerror = error => {
            reject(error)
          }
          img.src = url + '?not-from-cache-please'
        })
      } else {
        return {
          text: '',
          margin: [0, 15, 0, 0]
        }
      }
    },

    async printPDF(orders, type) {
      var data = await this.formatTemplate(orders, type)
      var dd = {
        content: [data],
        pageSize: 'A4',
        pageMargins: [30, 30, 30, 30],
        styles: {
          header: {
            fontSize: 18,
            bold: true
          },
          bigger: {
            fontSize: 15,
            italics: true
          },
          paragraph: {
            fontWeight: 200,
            fontSize: this.regularsize
          },
          container: {
            margin: [2, 2, 2, 2]
          },
          receipt: {
            fontSize: 18,
            bold: true
          }
        },
        defaultStyle: {
          font: 'THSarabunNew',
          columnGap: 20
        }
      }
      this.loading = false
      const fileName = type === 'receipt' ? 'Receipt.pdf' : 'Invoice.pdf'
      pdfMake.createPdf(dd).download(fileName)
    },

    convertThaiToEnglish(thaiText) {
      function replaceAllWithObject(text, replacementMap) {
        const regex = new RegExp(
          Object.keys(replacementMap)
            .join('|')
            .replace(/ /g, '\\s+'),
          'g'
        )
        const replacedText = text.replace(regex, match => replacementMap[match] || match)
        return replacedText.replace(/\s+/g, ' ').trim()
      }
      const thaiToEnglishMap = {
        หนึ่ง: ' one',
        สอง: ' two',
        สาม: ' three',
        สี่: ' four',
        ห้า: ' five',
        หก: ' six',
        เจ็ด: ' seven',
        แปด: ' eight',
        เก้า: ' nine',
        สิบเอ็ด: ' eleven',
        สิบสอง: ' twelve',
        สิบสาม: ' thirteen',
        สิบสี่: ' fourteen',
        สิบห้า: ' fifteen',
        สิบหก: ' sixteen',
        สิบเจ็ด: ' seventeen',
        สิบแปด: ' eighteen',
        สิบเก้า: ' nineteen',
        ยี่สิบ: ' twenty',
        สามสิบ: ' thirty',
        สี่สิบ: ' forty',
        ห้าสิบ: ' fifty',
        หกสิบ: ' sixty',
        เจ็ดสิบ: ' seventy',
        แปดสิบ: ' eighty',
        เก้าสิบ: ' ninety',
        สิบ: ' ten',
        ร้อย: ' hundred',
        พัน: ' thousand',
        หมื่น: ' ten thousand',
        แสน: ' hundred thousand',
        ล้าน: ' million',
        บาท: ' baht',
        สตางค์: ' stang',
        ถ้วน: ' '
      }
      const word = replaceAllWithObject(thaiText, thaiToEnglishMap)
      return word.charAt(0).toUpperCase() + word.slice(1)
    },

    genTextPrice(price) {
      const oneDigit = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
      const teens = [
        'eleven',
        'twelve',
        'thirteen',
        'fourteen',
        'fifteen',
        'sixteen',
        'seventeen',
        'eighteen',
        'nineteen'
      ]
      const twoDigit = [
        '',
        '',
        'twenty',
        'thirty',
        'forty',
        'fifty',
        'sixty',
        'seventy',
        'eighty',
        'ninety'
      ]

      function convertUnder100(num) {
        if (num === 10) {
          return 'ten'
        } else if (num < 10) {
          return oneDigit[num]
        } else if (num < 20) {
          return teens[num - 11]
        } else {
          const tens = Math.floor(num / 10)
          const ones = num % 10
          return twoDigit[tens] + (ones !== 0 ? ' ' + oneDigit[ones] : '')
        }
      }

      function convertUnder1000(num) {
        const hundreds = Math.floor(num / 100)
        const remainder = num % 100

        let result = ''

        if (hundreds !== 0) {
          result += oneDigit[hundreds] + ' hundred'

          if (remainder !== 0) {
            result += ' and '
          }
        }

        if (remainder !== 0) {
          result += convertUnder100(remainder)
        }

        return result
      }

      function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }

      if (price === 0) {
        return 'Zero Baht'
      } else if (price < 0) {
        return 'Negative '
      } else {
        let result = ''
        const integerPart = Math.floor(price)
        const decimalPart = Math.round((price - integerPart) * 100)

        if (integerPart >= 1000) {
          const thousands = Math.floor(integerPart / 1000)
          const remainder = integerPart % 1000

          result += convertUnder1000(thousands) + ' thousand '

          if (remainder !== 0) {
            result += convertUnder1000(remainder)
          }
        } else {
          result += convertUnder1000(integerPart)
        }

        if (decimalPart !== 0) {
          result += ' Baht and ' + convertUnder100(decimalPart) + ' Satang'
        } else {
          result += ' Baht'
        }

        return capitalizeFirstLetter(result.trim())
      }
    },

    getMsgFromLang(lang, msg) {
      return messages[lang][msg] || ''
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ExportInvoice.vue